export default __webpack_public_path__ + "3b5e8de0bfdf51863fed216534437311.png";